import { ChangeDetectionStrategy, Component, effect, inject, input, OnInit, output } from '@angular/core';
import { ChatRole, MessageContent } from '../../../../../models/agent.models';
import { MessageContentDisplayer } from './message-content-displayer/message-content-displayer';
import { WordData } from '../../../../../services/popup.service';
import { MessageOrchestrationService } from '../../../../../services/message-orchestration.service';

@Component({
  selector: 'dc-message-orchestrator',
  imports: [MessageContentDisplayer],
  templateUrl: './message-orchestrator.component.html',
  styleUrls: ['./message-orchestrator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MessageOrchestrationService],
})
export class ChatMessageOrchestratorComponent implements OnInit {
  // Services
  private orchestrationService = inject(MessageOrchestrationService);

  // Inputs
  messages = input.required<MessageContent[]>();
  messageRole = input.required<ChatRole>();

  // Outputs
  audioCompleted = output<MessageContent>();

  // Signals
  messagesSignal = this.orchestrationService.messagesSignal;

  ngOnInit(): void {
    this.orchestrationService.startOrchestration(this.messages(), this.messageRole());
  }

  public onAudioCompleted(message: MessageContent): void {
    this.orchestrationService.audioCompleted(message);
    this.audioCompleted.emit(message);
  }

  public onWordClicked(wordData: WordData): void {
    this.orchestrationService.wordClicked(wordData);
  }
}
